// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1jydE","left":"StickyBox_left__zwz8Q","right":"StickyBox_right__X3GdW"};